import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'
class QualityAssuranceTopics extends React.Component {
    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3 className="inline-block-element"><b>品質保証・返品について</b></h3>
                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/qualityassurance'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 保証はどうなりますか？</b>
                            </h4>
                        </Link>

                    </div>



                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("b")}>
                        <Link to='/qualityassurance'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 保証期間はいつまでですか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("c")}>
                        <Link to='/qualityassurance'>
                            <h4><b className="reduce-font-size cart-row-text-color"> どのような場合が保証対象外ですか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("d")}>
                        <Link to='/qualityassurance'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 返品したいのですが？</b>
                            </h4>
                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("e")}>
                        <Link to='/qualityassurance'>
                            <h4><b className="reduce-font-size cart-row-text-color"> どこに返品すればいいですか？</b>
                            </h4>

                        </Link>

                    </div>
                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("f")}>
                        <Link to='/qualityassurance'>
                            <h4><b  className="reduce-font-size cart-row-text-color"> 返品送料の負担について教えて下さい。</b>
                            </h4>

                        </Link>

                    </div>

                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
                </div>

        );
    }
}

export default QualityAssuranceTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/QualityAssuranceTopics.js